module.exports = "<div class=\"container hpd responsiveMobile schedule-mobile\">\n  <calendar-grid user=\"$ctrl.scheduleData\"\n                 loaded=\"$ctrl.loaded\"\n                 is-mobile-app=\"$ctrl.isMobileApp\"\n                 is-mobile-schedule=\"$ctrl.isMobileSchedule\"\n                 date-today=\"$ctrl.dateToday\">\n  </calendar-grid>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/features/scheduleMobile/scheduleMobile.html
// module id = 1357
// module chunks = 0